<style lang="less">
    .btn{
        display: inline-block;
        height: 30px;
        background: #fff;
        color: #333;
        font-size: 14px;
        padding: 0 10px;
        border-radius: 3px;
        line-height: 30px;
        margin-left: 50px;
        vertical-align: middle;
        cursor: pointer;
    }
    .p2{
        font-size:14px;
        line-height:40px;
        span{
            font-size: 16px;
            color: #f00;
            padding:0 3px;
        }
    }
    .notify{
        float: right;
        color: #fff;
        font-size: 16px;
        margin-right: 20px;
    }
</style>
<template>
  <div class="header-bar">
    <img src="../../../../assets/images/newlogo.png" style="margin:14px 0 0;vertical-align:top;"/>
    <div class="btn" @click="getUrl">邀请注册</div>
    <div class="notify" @click="goNotify">消息通知</div>
    <!--<sider-trigger :collapsed="collapsed" icon="navicon-round" @on-change="handleCollpasedChange"></sider-trigger>-->
    <!--<custom-bread-crumb show-icon style="margin-left: 30px;" :list="breadCrumbList"></custom-bread-crumb>-->
    <div class="custom-content-con">
      <slot></slot>
    </div>
    <span style="margin:0 15px 0;font-size:25px;color:#fff;float:right;font-family:serif;letter-spacing:1px;padding-top: 4px;">{{$store.state.user.enterpriseName}}</span>
    <Modal
        v-model="tips"
        title="邀请链接"
        ok-text="邀请列表"
        @on-ok="goList">
        <p style="display:inline-block;border:1px solid #eee; width:240px; padding:6px 10px; margin-right:10px">{{businessId_url}}</p>
        <Button style="display:inline-block" type="primary" data-clipboard-action="copy" class="cobyDomObj" :data-clipboard-text="businessId_url" @click="copyLink">复制</Button>
        <p class="p2">已邀请<span>{{scoreObj.inviteCount}}</span>家，获得<span>{{scoreObj.inviteScore}}</span>积分，剩余<span>{{scoreObj.remainderScore}}</span>积分</p>
    </Modal>
  </div>
</template>
<script>
import siderTrigger from './sider-trigger';
import customBreadCrumb from './custom-bread-crumb';
import { getBusinessId } from '@/libs/util';
import { encryptionSignResult } from '@/libs/tools'
import { inviteScore } from '@/api/data'
import './header-bar.less'
export default {
  name: 'HeaderBar',
  components: {
    siderTrigger,
    customBreadCrumb
  },
  props: {
    collapsed: Boolean
  },
  data() {
      return {
          tips: false,
        //   businessId_url: 'http://hr.noahhr.com/reg?id=U'+ getBusinessId(),
          businessId_url: 'http://hr.noahhr.com/reg?id=U'+ getBusinessId(),
          scoreObj: {}

      }
  },
  computed: {
    breadCrumbList () {
      // console.log(this.$store.state.app.breadCrumbList)
      return this.$store.state.app.breadCrumbList
    }
  },
  methods: {
    //   一键复制
    copyLink() {
        let _this = this;
        let clipboardObj = new this.clipboard(".cobyDomObj");
        clipboardObj.on('success', function () {
            _this.$Message.success("复制成功");
        });
        clipboardObj.on('error', function () {
            _this.$Message.info("复制失败");
        });
    },
    handleCollpasedChange (state) {
      this.$emit('on-coll-change', state)
    },
    getUrl() {
        this.getInvited();
    },
    goNotify() {
        this.$router.push({name: 'workbench-notify'});
    },
    goList() {
        this.tips = false;
        this.$router.push({name: 'business-list'});
    },
    getInvited() {
        let objData = encryptionSignResult({});
        inviteScore(objData).then(res => {
            if(res){
                this.scoreObj = res.data;
                this.tips = true;
            }
        })
        .catch((error) => {
            console.log("错误")
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/main/components/header-bar/header-bar.vue